// Menu data for the website.
//
// AxelPOS publishes the whole menu as one document, settings/publicMenu
// (categories, items, options, offers, fees, delivery, schedule, theme).
// Reading it costs 1 read per visit instead of 300 to 500.
//
// Until a restaurant's POS has published it, every function here falls back
// to reading the collection itself, as the site did before.
const db = window.firebase.firestore();

let menuPromise = null;
const fallbackCache = {};

// The published document, or null. Loaded once per page.
// Also used by siteConfig.js for the restaurant settings ("web").
export function loadPublished() {
  if (!menuPromise) {
    menuPromise = db.collection("settings").doc("publicMenu").get()
      .then(snap => (snap.exists ? snap.data() : null))
      .catch(() => null);
  }
  return menuPromise;
}

// All rows of a collection: [{ id, ...fields }].
export async function getCollection(name) {
  const menu = await loadPublished();
  if (menu && Array.isArray(menu[name])) return menu[name];
  if (!fallbackCache[name]) {
    fallbackCache[name] = db.collection(name).get()
      .then(snap => snap.docs.map(d => ({ id: d.id, ...d.data() })))
      .catch(() => { delete fallbackCache[name]; return []; });
  }
  return fallbackCache[name];
}

// One row by document id, or null.
export async function getDocById(name, id) {
  const rows = await getCollection(name);
  return rows.find(r => r.id === id) || null;
}

// Rows where every field equals the given value: where(rows, { category: "Pizza" }).
export function where(rows, filters) {
  return rows.filter(r => Object.entries(filters).every(([k, v]) => r[k] === v));
}

// For code written for Firestore snapshots: { id, data() }.
export const asSnapshots = (rows) => rows.map(r => ({ id: r.id, data: () => r }));

// My Menu > Promotions rules, or null when the restaurant has not saved any
// (then the old "global" offer of Marketing > Offers still applies).
let rulesPromise = null;
export function getPromotionRules() {
  if (!rulesPromise) {
    rulesPromise = loadPublished().then(menu => {
      if (menu && "promotions" in menu) return Array.isArray(menu.promotions) ? menu.promotions : null;
      return db.collection("settings").doc("promotions").get()
        .then(snap => (snap.exists ? (snap.data().rules || []) : null))
        .catch(() => null);
    });
  }
  return rulesPromise;
}
